import { useRef } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import ContactCard from './ContactCard';

export default function BlogArticleLayout({ title, image, imageAlt, ctaLabel, children }) {
  const contactRef = useRef(null);

  const focusContact = () => {
    if (contactRef.current?.focusForm) {
      contactRef.current.focusForm();
    }
  };

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-br from-white via-sky-50 to-indigo-100 font-sans text-slate-900">
      <Navbar onTalkClick={focusContact} />

      <main className="flex-1">
        <article className="mx-auto max-w-3xl px-6 pt-32 pb-16">
          <h1 className="text-4xl font-semibold text-slate-900 md:text-5xl">{title}</h1>

          {image ? (
            <img src={image} alt={imageAlt ?? title} className="my-8 w-full rounded-3xl border border-slate-200 shadow-sm" />
          ) : null}

          <div className="space-y-6 text-lg leading-relaxed text-slate-600">{children}</div>

          {ctaLabel ? (
            <div className="mt-12 text-center">
              <button
                onClick={focusContact}
                className="rounded-full bg-slate-900 px-6 py-3 text-white shadow transition hover:opacity-90"
              >
                {ctaLabel}
              </button>
            </div>
          ) : null}
        </article>
      </main>

      <ContactCard ref={contactRef} />
      <Footer />
    </div>
  );
}
